import { useEffect, useRef } from 'react';

type Props = {
  src: string;
  poster: string;
  label: string;
  /** Show native controls (lets visitors unmute or scrub). */
  controls?: boolean;
  aspectClass?: string;
  className?: string;
};

// Real output clips from the production pipeline. Autoplays muted and looped; respects
// prefers-reduced-motion by leaving the poster in place instead of starting playback.
export default function LoopVideo({ src, poster, label, controls = false, aspectClass = 'aspect-[9/16]', className = '' }: Props) {
  const ref = useRef<HTMLVideoElement>(null);
  useEffect(() => {
    const video = ref.current;
    if (!video) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      video.pause();
      return;
    }
    video.play().catch(() => undefined);
  }, []);
  return (
    <video
      ref={ref}
      className={`block w-full rounded-xl bg-gray-900 object-cover ${aspectClass} ${className}`}
      src={src}
      poster={poster}
      autoPlay
      muted
      loop
      playsInline
      controls={controls}
      preload="metadata"
      aria-label={label}
    />
  );
}
